export default __webpack_public_path__ + "static/media/file.a3816baa.png";